/// <reference path="../app.js"/>

class HeaderBehaviour {
	// static checkWidth() {
	// 	if (this.width > window.innerWidth - 120) {
	// 		$("header").addClass("mobile");
	// 	}
	// 	else {
	// 		$("header").removeClass("mobile");
	// 	}
	// }

    static init() {}

	// static init() {
	// 	this.width = 0;
	// 	$("header > .main, header > .region-options").each((index, element) => {
	// 		this.width += parseInt(getComputedStyle(element).width) - 120;
	// 	});
    //
	// 	$("header .flyout-menu-button").on("click", () => {
	// 		$("header").toggleClass("open-menu");
	// 	});
    //
	// 	this.checkWidth();
    //
	// 	$(window).on("resize", () => {
	// 		this.checkWidth();
	// 	});
	// }
}
